export const SHIP_TYPES = {
  // ─── EXPRESS / COURIER ────────────────────────────────────
  SPEEDBOAT: {
    id: 'speedboat',
    name: 'Fast Courier',
    description: 'Small but fast, perfect for urgent deliveries',
    category: 'express',
    cargoCapacity: 20,
    maxFuel: 50,
    maxSpeed: 32,
    cruiseSpeed: 26,
    fuelConsumption: 8,
    fuelConsumptionMax: 16,
    basePurchasePrice: 500000,
    dailyOperatingCost: 800,
    maintenanceCostPerDay: 150,
    minCrewRequired: 4,
    extraCrewSlots: 0,
    requiredLevel: 2,
    requiredUnlock: null,
    range: 1400,
    cargoRestrictions: null
  },

  EXPRESS_CLIPPER: {
    id: 'express_clipper',
    name: 'Express Clipper',
    description: 'Mid-range express vessel for regional high-value runs',
    category: 'express',
    cargoCapacity: 50,
    maxFuel: 120,
    maxSpeed: 29,
    cruiseSpeed: 24,
    fuelConsumption: 14,
    fuelConsumptionMax: 24,
    basePurchasePrice: 1800000,
    dailyOperatingCost: 1500,
    maintenanceCostPerDay: 250,
    minCrewRequired: 6,
    extraCrewSlots: 1,
    requiredLevel: 4,
    requiredUnlock: 'express_license',
    range: 2600,
    cargoRestrictions: null
  },

  EXPRESS_FREIGHTER: {
    id: 'express_freighter',
    name: 'Express Freighter',
    description: 'Fast freighter for intercontinental premium cargo',
    category: 'express',
    cargoCapacity: 120,
    maxFuel: 300,
    maxSpeed: 27,
    cruiseSpeed: 22,
    fuelConsumption: 22,
    fuelConsumptionMax: 38,
    basePurchasePrice: 8000000,
    dailyOperatingCost: 4000,
    maintenanceCostPerDay: 500,
    minCrewRequired: 10,
    extraCrewSlots: 2,
    requiredLevel: 6,
    requiredUnlock: 'express_license',
    range: 4200,
    cargoRestrictions: null
  },

  SWIFT_INTERCEPTOR: {
    id: 'swift_interceptor',
    name: 'Swift Interceptor',
    description: 'The fastest commercial vessel afloat — built for discretion and speed',
    category: 'express',
    cargoCapacity: 200,
    maxFuel: 500,
    maxSpeed: 34,
    cruiseSpeed: 28,
    fuelConsumption: 34,
    fuelConsumptionMax: 60,
    basePurchasePrice: 25000000,
    dailyOperatingCost: 8000,
    maintenanceCostPerDay: 900,
    minCrewRequired: 14,
    extraCrewSlots: 2,
    requiredLevel: 9,
    requiredUnlock: 'express_license',
    range: 5500,
    cargoRestrictions: null
  },

  // ─── CARGO / CONTAINER VESSELS ───────────────────────────
  COASTAL_TRADER: {
    id: 'coastal_trader',
    name: 'Coastal Trader',
    description: 'Nimble coaster for short-range port hopping',
    category: 'cargo',
    cargoCapacity: 50,
    maxFuel: 80,
    maxSpeed: 12,
    cruiseSpeed: 10,
    fuelConsumption: 3,
    fuelConsumptionMax: 5,
    basePurchasePrice: 350000,
    dailyOperatingCost: 600,
    maintenanceCostPerDay: 60,
    minCrewRequired: 4,
    extraCrewSlots: 1,
    requiredLevel: 1,
    requiredUnlock: null,
    range: 1500,
    cargoRestrictions: null
  },

  SMALL_CARGO: {
    id: 'small_cargo',
    name: 'Small Feeder Vessel',
    description: 'Affordable feeder coaster for intra-regional trading',
    category: 'cargo',
    cargoCapacity: 100,
    maxFuel: 200,
    maxSpeed: 14,
    cruiseSpeed: 11,
    fuelConsumption: 6,
    fuelConsumptionMax: 9,
    basePurchasePrice: 1000000,
    dailyOperatingCost: 1000,
    maintenanceCostPerDay: 100,
    minCrewRequired: 6,
    extraCrewSlots: 2,
    requiredLevel: 1,
    requiredUnlock: null,
    range: 2400,
    cargoRestrictions: null
  },

  MEDIUM_CARGO: {
    id: 'medium_cargo',
    name: 'Regional Feeder Freighter',
    description: 'Reliable workhorse feeder for coastal and regional loops',
    category: 'cargo',
    cargoCapacity: 500,
    maxFuel: 800,
    maxSpeed: 16,
    cruiseSpeed: 13,
    fuelConsumption: 16,
    fuelConsumptionMax: 26,
    basePurchasePrice: 6000000,
    dailyOperatingCost: 3000,
    maintenanceCostPerDay: 300,
    minCrewRequired: 12,
    extraCrewSlots: 2,
    requiredLevel: 3,
    requiredUnlock: null,
    range: 3500,
    cargoRestrictions: null
  },

  HANDYSIZE_BULK: {
    id: 'handysize_bulk',
    name: 'Handysize Bulk Carrier',
    description: 'Geared bulk carrier that accesses smaller regional ports',
    category: 'cargo',
    cargoCapacity: 1000,
    maxFuel: 1200,
    maxSpeed: 15,
    cruiseSpeed: 13,
    fuelConsumption: 24,
    fuelConsumptionMax: 38,
    basePurchasePrice: 15000000,
    dailyOperatingCost: 5000,
    maintenanceCostPerDay: 500,
    minCrewRequired: 16,
    extraCrewSlots: 2,
    requiredLevel: 4,
    requiredUnlock: null,
    range: 5200,
    cargoRestrictions: null
  },

  LARGE_CARGO: {
    id: 'large_cargo',
    name: 'Sub-Panamax Container Ship',
    description: 'Fast container ship for mainline-to-feeder connection',
    category: 'cargo',
    cargoCapacity: 2000,
    maxFuel: 2000,
    maxSpeed: 19,
    cruiseSpeed: 16,
    fuelConsumption: 45,
    fuelConsumptionMax: 75,
    basePurchasePrice: 35000000,
    dailyOperatingCost: 8000,
    maintenanceCostPerDay: 800,
    minCrewRequired: 18,
    extraCrewSlots: 2,
    requiredLevel: 6,
    requiredUnlock: 'large_vessel_permit',
    range: 6800,
    cargoRestrictions: null
  },

  PANAMAX: {
    id: 'panamax',
    name: 'Panamax Container Ship',
    description: 'Classic high-speed liner designed for global waterways',
    category: 'cargo',
    cargoCapacity: 4000,
    maxFuel: 3500,
    maxSpeed: 23,
    cruiseSpeed: 19,
    fuelConsumption: 75,
    fuelConsumptionMax: 120,
    basePurchasePrice: 80000000,
    dailyOperatingCost: 14000,
    maintenanceCostPerDay: 1400,
    minCrewRequired: 20,
    extraCrewSlots: 3,
    requiredLevel: 8,
    requiredUnlock: 'large_vessel_permit',
    range: 8500,
    cargoRestrictions: null
  },

  POST_PANAMAX: {
    id: 'post_panamax',
    name: 'Post-Panamax Container Ship',
    description: 'Wide-beam container giant built for high-volume transpacific runs',
    category: 'cargo',
    cargoCapacity: 8000,
    maxFuel: 6000,
    maxSpeed: 22,
    cruiseSpeed: 18,
    fuelConsumption: 125,
    fuelConsumptionMax: 190,
    basePurchasePrice: 200000000,
    dailyOperatingCost: 25000,
    maintenanceCostPerDay: 2500,
    minCrewRequired: 22,
    extraCrewSlots: 3,
    requiredLevel: 10,
    requiredUnlock: 'mega_vessel_auth',
    range: 11000,
    cargoRestrictions: null
  },

  NEW_PANAMAX: {
    id: 'new_panamax',
    name: 'New Panamax Container Ship',
    description: 'Tailored for the expanded locks — modern 13 000 TEU workhorse',
    category: 'cargo',
    cargoCapacity: 13000,
    maxFuel: 9000,
    maxSpeed: 21,
    cruiseSpeed: 18,
    fuelConsumption: 185,
    fuelConsumptionMax: 275,
    basePurchasePrice: 350000000,
    dailyOperatingCost: 40000,
    maintenanceCostPerDay: 4000,
    minCrewRequired: 24,
    extraCrewSlots: 3,
    requiredLevel: 12,
    requiredUnlock: 'mega_vessel_auth',
    range: 13000,
    cargoRestrictions: null
  },

  ULCV: {
    id: 'ulcv',
    name: 'Ultra-Large Container Vessel',
    description: 'Massive 18 000 TEU ship connecting Asia and Europe at steady pace',
    category: 'cargo',
    cargoCapacity: 18000,
    maxFuel: 12000,
    maxSpeed: 21,
    cruiseSpeed: 17,
    fuelConsumption: 240,
    fuelConsumptionMax: 360,
    basePurchasePrice: 500000000,
    dailyOperatingCost: 55000,
    maintenanceCostPerDay: 5500,
    minCrewRequired: 24,
    extraCrewSlots: 3,
    requiredLevel: 14,
    requiredUnlock: 'ultra_large_vessels',
    range: 14500,
    cargoRestrictions: null
  },

  TRIPLE_E: {
    id: 'triple_e',
    name: 'Megamax-24 Class',
    description: 'The pinnacle of economies of scale — 24 000 TEU capacity',
    category: 'cargo',
    cargoCapacity: 24000,
    maxFuel: 16000,
    maxSpeed: 20,
    cruiseSpeed: 17,
    fuelConsumption: 290,
    fuelConsumptionMax: 440,
    basePurchasePrice: 680000000,
    dailyOperatingCost: 70000,
    maintenanceCostPerDay: 7000,
    minCrewRequired: 26,
    extraCrewSlots: 3,
    requiredLevel: 16,
    requiredUnlock: 'ultra_large_vessels',
    range: 16000,
    cargoRestrictions: null
  },

  // ─── RO-RO & REEFER (SPECIALIZED) ────────────────────────
  RORO: {
    id: 'roro',
    name: 'Pure Car Carrier (PCTC)',
    description: 'High-speed roll-on/roll-off vessel for automotive freight schedules',
    category: 'specialized',
    cargoCapacity: 800,
    maxFuel: 1200,
    maxSpeed: 21,
    cruiseSpeed: 18,
    fuelConsumption: 38,
    fuelConsumptionMax: 60,
    basePurchasePrice: 22000000,
    dailyOperatingCost: 6500,
    maintenanceCostPerDay: 600,
    minCrewRequired: 18,
    extraCrewSlots: 2,
    requiredLevel: 5,
    requiredUnlock: 'roro_certification',
    range: 6000,
    cargoRestrictions: ['automobiles', 'trucks', 'machinery'],
    loadingFeeModifier: 0.3,
    loadingTimeModifier: 0.5   // vehicles drive on/off — no crane moves
  },

  REEFER: {
    id: 'reefer',
    name: 'Fast Refrigerated Trader',
    description: 'Express temperature-controlled ship to prevent perishables from spoiling',
    category: 'specialized',
    cargoCapacity: 300,
    maxFuel: 700,
    maxSpeed: 20,
    cruiseSpeed: 17,
    fuelConsumption: 28,
    fuelConsumptionMax: 45,
    basePurchasePrice: 9500000,
    dailyOperatingCost: 5500,
    maintenanceCostPerDay: 500,
    minCrewRequired: 12,
    extraCrewSlots: 2,
    requiredLevel: 4,
    requiredUnlock: 'refrigeration_permit',
    range: 4200,
    cargoRestrictions: ['meat', 'fruit_vegetables', 'dairy', 'frozen_goods', 'medical', 'seafood']
  },

  LARGE_REEFER: {
    id: 'large_reefer',
    name: 'Oceanic Reefer Vessel',
    description: 'High-capacity refrigerated carrier designed for intercontinental fruit runs',
    category: 'specialized',
    cargoCapacity: 1200,
    maxFuel: 1900,
    maxSpeed: 21,
    cruiseSpeed: 18,
    fuelConsumption: 55,
    fuelConsumptionMax: 85,
    basePurchasePrice: 38000000,
    dailyOperatingCost: 11000,
    maintenanceCostPerDay: 1000,
    minCrewRequired: 18,
    extraCrewSlots: 2,
    requiredLevel: 7,
    requiredUnlock: 'refrigeration_permit',
    range: 7000,
    cargoRestrictions: ['meat', 'fruit_vegetables', 'dairy', 'frozen_goods', 'medical', 'seafood']
  },

  // ─── TANKERS & GAS CARRIERS ──────────────────────────────
  COASTAL_TANKER: {
    id: 'coastal_tanker',
    name: 'Coastal Tanker',
    description: 'Small tanker for short-haul chemical and refined product runs',
    category: 'tanker',
    cargoCapacity: 200,
    maxFuel: 120,
    maxSpeed: 13,
    cruiseSpeed: 11,
    fuelConsumption: 6,
    fuelConsumptionMax: 10,
    basePurchasePrice: 3500000,
    dailyOperatingCost: 2000,
    maintenanceCostPerDay: 200,
    minCrewRequired: 7,
    extraCrewSlots: 2,
    requiredLevel: 3,
    requiredUnlock: 'tanker_license',
    range: 2500,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  PRODUCT_TANKER: {
    id: 'product_tanker',
    name: 'Handy Product Tanker',
    description: 'Medium-range tanker for refined fuels and edible oils',
    category: 'tanker',
    cargoCapacity: 600,
    maxFuel: 600,
    maxSpeed: 14,
    cruiseSpeed: 12,
    fuelConsumption: 16,
    fuelConsumptionMax: 26,
    basePurchasePrice: 14000000,
    dailyOperatingCost: 5000,
    maintenanceCostPerDay: 500,
    minCrewRequired: 14,
    extraCrewSlots: 2,
    requiredLevel: 5,
    requiredUnlock: 'tanker_license',
    range: 5200,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  GENERAL_TANKER: {
    id: 'general_tanker',
    name: 'MR2 General Tanker',
    description: 'Medium-range tanker built for global distribution of clean petroleum',
    category: 'tanker',
    cargoCapacity: 1500,
    maxFuel: 1800,
    maxSpeed: 15,
    cruiseSpeed: 13,
    fuelConsumption: 32,
    fuelConsumptionMax: 50,
    basePurchasePrice: 32000000,
    dailyOperatingCost: 9000,
    maintenanceCostPerDay: 900,
    minCrewRequired: 18,
    extraCrewSlots: 2,
    requiredLevel: 7,
    requiredUnlock: 'tanker_license',
    range: 6500,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  AFRAMAX_TANKER: {
    id: 'aframax_tanker',
    name: 'Aframax Tanker',
    description: 'Regional heavy crude tanker for short-to-medium sea routes',
    category: 'tanker',
    cargoCapacity: 4000,
    maxFuel: 4000,
    maxSpeed: 15,
    cruiseSpeed: 13,
    fuelConsumption: 55,
    fuelConsumptionMax: 85,
    basePurchasePrice: 80000000,
    dailyOperatingCost: 16000,
    maintenanceCostPerDay: 1600,
    minCrewRequired: 20,
    extraCrewSlots: 3,
    requiredLevel: 9,
    requiredUnlock: 'tanker_license',
    range: 8500,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  SUEZMAX_TANKER: {
    id: 'suezmax_tanker',
    name: 'Suezmax Tanker',
    description: 'Full-draft canal transit tanker for crude trades',
    category: 'tanker',
    cargoCapacity: 8000,
    maxFuel: 6000,
    maxSpeed: 15,
    cruiseSpeed: 13,
    fuelConsumption: 85,
    fuelConsumptionMax: 135,
    basePurchasePrice: 180000000,
    dailyOperatingCost: 28000,
    maintenanceCostPerDay: 2800,
    minCrewRequired: 22,
    extraCrewSlots: 3,
    requiredLevel: 11,
    requiredUnlock: 'mega_vessel_auth',
    range: 10500,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  VLCC: {
    id: 'vlcc',
    name: 'VLCC',
    description: 'Very Large Crude Carrier — moving 2 million barrels across oceans',
    category: 'tanker',
    cargoCapacity: 16000,
    maxFuel: 10000,
    maxSpeed: 15,
    cruiseSpeed: 12.5,
    fuelConsumption: 140,
    fuelConsumptionMax: 210,
    basePurchasePrice: 430000000,
    dailyOperatingCost: 45000,
    maintenanceCostPerDay: 4500,
    minCrewRequired: 24,
    extraCrewSlots: 3,
    requiredLevel: 13,
    requiredUnlock: 'mega_vessel_auth',
    range: 12500,
    cargoRestrictions: ['crude_oil', 'refined_oil', 'chemicals', 'palm_oil']
  },

  ULCC: {
    id: 'ulcc',
    name: 'ULCC Titan',
    description: 'Ultra Large Crude Carrier — unrivaled crude oil capacity',
    category: 'tanker',
    cargoCapacity: 30000,
    maxFuel: 16000,
    maxSpeed: 14,
    cruiseSpeed: 12,
    fuelConsumption: 220,
    fuelConsumptionMax: 330,
    basePurchasePrice: 850000000,
    dailyOperatingCost: 70000,
    maintenanceCostPerDay: 7000,
    minCrewRequired: 26,
    extraCrewSlots: 3,
    requiredLevel: 16,
    requiredUnlock: 'ultra_large_vessels',
    range: 14000,
    cargoRestrictions: ['crude_oil', 'refined_oil']
  },

  LNG_CARRIER: {
    id: 'lng_carrier',
    name: 'LNG Carrier',
    description: 'Cryogenic membrane carrier with gas-fueled high cruise speed',
    category: 'tanker',
    cargoCapacity: 2500,
    maxFuel: 3000,
    maxSpeed: 19,
    cruiseSpeed: 16,
    fuelConsumption: 58,
    fuelConsumptionMax: 90,
    basePurchasePrice: 100000000,
    dailyOperatingCost: 18000,
    maintenanceCostPerDay: 2200,
    minCrewRequired: 22,
    extraCrewSlots: 3,
    requiredLevel: 10,
    requiredUnlock: 'lng_handling',
    range: 9000,
    cargoRestrictions: ['lng']
  },

  LARGE_LNG_CARRIER: {
    id: 'large_lng_carrier',
    name: 'Q-Max LNG Carrier',
    description: 'The premier Qatar-Max cryogenic giant for high-volume pipelines on water',
    category: 'tanker',
    cargoCapacity: 5000,
    maxFuel: 5500,
    maxSpeed: 20,
    cruiseSpeed: 17,
    fuelConsumption: 95,
    fuelConsumptionMax: 145,
    basePurchasePrice: 200000000,
    dailyOperatingCost: 32000,
    maintenanceCostPerDay: 3200,
    minCrewRequired: 24,
    extraCrewSlots: 3,
    requiredLevel: 12,
    requiredUnlock: 'lng_handling',
    range: 11500,
    cargoRestrictions: ['lng']
  }
};

// Ship categories for the broker UI
export const SHIP_CATEGORIES = {
  cargo:       { label: 'Container / Cargo', description: 'General-purpose container and bulk carriers' },
  tanker:      { label: 'Tankers',           description: 'Liquid and gas carriers' },
  specialized: { label: 'Specialized',       description: 'RoRo, refrigerated, and other specialist vessels' },
  express:     { label: 'Express',           description: 'Fast vessels for high-value and time-sensitive cargo' }
};

// Lookup by id string
export function getShipType(id) {
  return Object.values(SHIP_TYPES).find(t => t.id === id) || null;
}
